import React from 'react';

const iconSrc =
  'https://res.cloudinary.com/letsdothiscom/image/upload/v1551809091/static-assets/icons/right%20arrow%20-%20grey.svg';

const CheveronRightIcon = (props) => {
  return <img {...props} src={iconSrc} alt="Cheveron Right Icon" />;
};

export default CheveronRightIcon;
